/* eslint-disable prettier/prettier */
// services/userService.ts

import { apiService } from './api.service';
import { UserListResponse } from '../types/user';

export const userService = {
	// 🔥 Generic user fetch with filters
	async getUsers(filters?: {
		role?: string;
		accountstatus?: string;
		search?: string;
		isactive?: boolean;
		page?: number;
		limit?: number;
	}) {
		try {
			const response = await apiService.get<UserListResponse>(
				'user',
				filters
			);

			return {
				success: true,
				data: response.data,
			};
		} catch (error: any) {
			console.error('Error fetching users:', error);

			return {
				success: false,
				message:
					error?.response?.data?.message ||
					error?.message ||
					'Failed to fetch users',
			};
		}
	},

	// 🔥 Coaches / Mentors
	async getCoaches(type: 'coach' | 'mentor') {
		try {
			const response = await apiService.get<any>('/user/coaches', {
				type,
			});

			return {
				success: true,
				data: response.data,
			};
		} catch (error: any) {
			console.error('Error fetching coaches:', error);

			return {
				success: false,
				message:
					error?.response?.data?.message ||
					error?.message ||
					'Failed to fetch coaches',
			};
		}
	},

	// 🔥 Admin / Superadmin users
	async getAdmins() {
		try {
			const response = await apiService.get<UserListResponse>('/user', {
				role: 'admin', // can also call twice for superadmin if needed
			});

			return {
				success: true,
				data: response.data,
			};
		} catch (error: any) {
			console.error('Error fetching admins:', error);

			return {
				success: false,
				message:
					error?.response?.data?.message ||
					error?.message ||
					'Failed to fetch admins',
			};
		}
	},

	// 🔥 Combined Admin + Superadmin
	async getAdminAndSuperAdmins() {
		try {
			// You can extend backend to accept multiple roles, but for now:
			const [admins, superadmins] = await Promise.all([
				apiService.get<UserListResponse>('/user', { role: 'admin' }),
				apiService.get<UserListResponse>('/user', {
					role: 'superadmin',
				}),
			]);

			const combinedUsers = [
				...(admins.data.users || []),
				...(superadmins.data.users || []),
			];

			return {
				success: true,
				data: combinedUsers,
			};
		} catch (error: any) {
			console.error('Error fetching admin + superadmin:', error);

			return {
				success: false,
				message:
					error?.response?.data?.message ||
					error?.message ||
					'Failed to fetch admin users',
			};
		}
	},
};
